import config from "../config"
const baseUrl = config.base_url + "agricultural_store_pesticide_fertilizer/"
export default {
    findByStoreAndPesticides: {
        url: baseUrl + "findByStoreAndPesticides",
        type: "post",
    },
    findByStore: {
        url: baseUrl + "findByStore",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    saveBatch: {
        url: baseUrl + "saveBatch",
        type: "post",
    },
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    }
}
